import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { User, Heart, LayoutDashboard, LogOut, ChevronDown, Sparkles, TrendingUp } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import AuthModal from "./AuthModal";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "./ui/dropdown-menu";

const portalPath = (role) => {
  if (role === "admin" || role === "agent") return "/admin";
  return "/portal";
};

const AccountMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [authOpen, setAuthOpen] = useState(false);

  const doLogout = () => { logout(); navigate("/"); };

  if (!user) {
    return (
      <>
        <button
          onClick={() => setAuthOpen(true)}
          className="hidden sm:inline-flex items-center gap-2 text-[14px] font-400 text-[#2b2b2b] hover:text-[#b8935f] transition-colors"
        >
          <User size={17} /> Sign In
        </button>
        <AuthModal open={authOpen} onOpenChange={setAuthOpen} defaultMode="login" />
      </>
    );
  }

  const initials = user.name.split(" ").map((n) => n[0]).slice(0, 2).join("");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 group">
          <span className="w-9 h-9 rounded-full bg-[#b8935f] text-white flex items-center justify-center text-[13px] font-500">
            {initials}
          </span>
          <ChevronDown size={15} className="text-[#6a6a6a] group-hover:text-[#b8935f] hidden sm:block" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <div className="px-3 py-2">
          <p className="text-[14px] font-500 text-[#2b2b2b]">{user.name}</p>
          <p className="text-[12px] text-[#8a8a8a] capitalize">{user.role} account</p>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate(portalPath(user.role))} className="cursor-pointer">
          <LayoutDashboard size={15} className="mr-2 text-[#b8935f]" /> Dashboard
        </DropdownMenuItem>
        {(user.role === "admin" || user.role === "agent") && (
          <DropdownMenuItem onClick={() => navigate("/marketing")} className="cursor-pointer">
            <Sparkles size={15} className="mr-2 text-[#b8935f]" /> Marketing Suite
          </DropdownMenuItem>
        )}
        {(user.role === "admin" || user.role === "agent") && (
          <DropdownMenuItem onClick={() => navigate("/growth")} className="cursor-pointer">
            <TrendingUp size={15} className="mr-2 text-[#b8935f]" /> Growth & Ops
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => navigate("/favourites")} className="cursor-pointer">
          <Heart size={15} className="mr-2 text-[#b8935f]" /> Saved Homes
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={doLogout} className="cursor-pointer text-red-600">
          <LogOut size={15} className="mr-2" /> Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AccountMenu;
